// @flow

import type {Language, GraphData, PortfolioNotificationEvent} from '../types'
import customTooltip from './tooltip'

import React from 'react'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import {getEvents} from '../store/util'
import {selectThemeColours} from '@/theme-colours'
import {getSessionPartnerId} from '@/partnerID'

type Props = {
  l: Language,
  themeColour: string,
  data: Array<GraphData>,
  title: string,
  notifications: Array<PortfolioNotificationEvent>,
  updateFilteredData: Function,
}

const dot = (colour) => {
  return {
    r: 3,
    fill: colour,
    stroke: colour,
    strokeWidth: 0,
  }
}

const RawLineChart = (props: Props) =>
  <div>
    <h4>{props.title}</h4>
    <ResponsiveContainer height={250} width="100%">
      <AreaChart
        width={900}
        height={150}
        margin={{top: 20, right: 0, left: -20, bottom: 20}}
        data={props.data}
        onClick={getEvents(props.notifications, props.updateFilteredData)}
      >
        <XAxis dataKey="key" label={{value: props.l('Event dates'), position: 'insideBottom', offset: -10}}/>
        <YAxis dataKey="value" label={{value: props.l('Number of events'), angle: -90}}/>
        <CartesianGrid stroke="#ccc" />
        <Tooltip content={customTooltip(props.l('Events'))}/>
        <Area
          type="linear"
          dataKey="value"
          stroke={props.themeColour}
          strokeWidth="2"
          fill="#eee"
          dot={dot(props.themeColour)}
          activeDot={dot(props.themeColour)}
          isAnimationActive={true}
        />
      </AreaChart>
    </ResponsiveContainer>
  </div>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  themeColour: selectThemeColours(getSessionPartnerId()).primaryColour,
})

export default connect(
  mapStateToProps,
)(RawLineChart)



// WEBPACK FOOTER //
// ./src/elements/line-chart.js